// app/PixelInits.tsx — Deferred pixel loading: only loads after first user interaction
"use client"

import { useEffect, useRef } from "react"

export function PixelInits() {
  const loaded = useRef(false)

  useEffect(() => {
    // Persist fbclid from Meta Ads so CAPI can build fbc on purchase
    try {
      const fbclid = new URLSearchParams(window.location.search).get("fbclid");
      if (fbclid) localStorage.setItem("fbclid", fbclid);
    } catch {}

    // Immediately init gtag stub so conversion calls (merci page at 1s) queue into dataLayer
    const w = window as any
    if (!w.gtag) {
      w.dataLayer = w.dataLayer || []
      w.gtag = function () { w.dataLayer.push(arguments) }
      w.gtag('js', new Date())
    }

    function loadPixels() {
      if (loaded.current) return
      loaded.current = true

      // Google Ads + GA4 via single gtag.js
      const gtagScript = document.createElement("script")
      gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=AW-11432059358"
      gtagScript.async = true
      document.head.appendChild(gtagScript)
      gtagScript.onload = () => {
        ;(window as any).gtag('config', 'AW-11432059358')
        ;(window as any).gtag('config', 'G-L2358QNSXD')
      }

      // Snapchat Pixel
      const snapScript = document.createElement("script")
      snapScript.src = "https://sc-static.net/scevent.min.js"
      snapScript.async = true
      document.head.appendChild(snapScript)
      snapScript.onload = () => {
        ;(window as any).snaptr('init', '81d6d061-ed0b-41d5-b53c-3013a858bb51', {})
        ;(window as any).snaptr('track', 'PAGE_VIEW')
      }
      // Init snaptr queue before script loads
      if (!(window as any).snaptr) {
        const a: any = (window as any).snaptr = function () { a.handleRequest ? a.handleRequest.apply(a, arguments) : a.queue.push(arguments) }
        a.queue = []
      }

      // TikTok Pixel
      const ww = window as any
      ww.TiktokAnalyticsObject = 'ttq'
      const ttq = ww.ttq = ww.ttq || []
      ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"]
      ttq.setAndDefer = function (t: any, e: string) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))) } }
      for (let i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i])
      ttq.instance = function (t: string) { const e = ttq._i[t] || []; for (let n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]); return e }
      ttq.load = function (e: string, n?: any) {
        const r = "https://analytics.tiktok.com/i18n/pixel/events.js"
        ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = r; ttq._t = ttq._t || {}; ttq._t[e] = +new Date; ttq._o = ttq._o || {}; ttq._o[e] = n || {}
        const s = document.createElement("script"); s.type = "text/javascript"; s.async = true; s.src = r + "?sdkid=" + e + "&lib=ttq"
        const a = document.getElementsByTagName("script")[0]; a.parentNode!.insertBefore(s, a)
      }
      ttq.load('CQ4L90JC77U5V8MCHL90')
      ttq.page()

    }

    // Load pixels immediately (no deferred loading)
    loadPixels()

    // Server-side Meta CAPI PageView — works even with ad-blockers
    fetch("/api/meta/event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event_name: "PageView",
        page_url: window.location.href,
        fbp: document.cookie.match(/_fbp=([^;]+)/)?.[1] || "",
        fbc: document.cookie.match(/_fbc=([^;]+)/)?.[1] || "",
      }),
    }).catch(() => {})
  }, [])

  return null
}
